import { RightRail, RightRailClose } from 'blaze-ui/icons'
import { Button } from 'common/Prose/Toolbar/ToolbarBravo/WriterFormatToolbar/Button'
import { observer } from 'mobx-react-lite'
import { useRootStore } from 'stores/RootStore'
import { useIsSystemRedesign } from 'hooks/useIsSystemRedesign'
import { IconButton } from 'blaze-ui/IconButton/IconButton'
import { ChevronDoubleLeft, ChevronDoubleRight } from 'blaze-ui/icons/24'

export const TabsToggleButton = observer(() => {
  const isSystemRedesignEnabled = useIsSystemRedesign()
  const { designStore, rightRailPanelStore } = useRootStore()

  if (!designStore) return null

  const toggle = () => {
    if (designStore.isTabOpen) {
      designStore.closeTab()
      rightRailPanelStore.hide()
    } else {
      designStore.openDefaultTab()
    }
  }

  if (isSystemRedesignEnabled) {
    return (
      <IconButton
        icon={() => (designStore.isTabOpen ? <ChevronDoubleRight size={18} /> : <ChevronDoubleLeft size={18} />)}
        size="xl"
        onPress={toggle}
        variant="tertiary"
      />
    )
  }

  return <Button icon={designStore.isTabOpen ? RightRailClose : RightRail} onPress={toggle} />
})
